<ng-template #noOutputDeviceBlock>
  <span class="no-device-message"> {{ 'audio_device.no_output_device' | translate }} </span>
</ng-template>

<ng-template #noInputDeviceBlock>
  <span class="no-device-message"> {{ 'audio_device.no_input_device' | translate }} </span>
</ng-template>

<ng-template #noRingDeviceOptions>
  <span class="no-device-message"> {{ 'audio_device.no_output_device' | translate }} </span>
</ng-template>

<div fxLayout="row" fxLayoutAlign="start center" *ngIf="!isJsSIP">
  <span class="title">{{ 'components.settings.output_device' | translate }}</span>
  <mat-icon *ngIf="!audioOutputOptions.length" class="error-text">error</mat-icon>
</div>

<div class="device-container" *ngIf="!isJsSIP">
  <ng-container *ngIf="audioOutputOptions.length; else noOutputDeviceBlock">
    <div class="selector-container">
      <div>
        <mat-form-field class="mat-input-sm mat-input-no-padding" appearance="outline">
          <mat-select [formControl]="audioOutputName" (selectionChange)="changeAudioOutput($event)">
            <mat-option value="*">Default</mat-option>
            <mat-option *ngFor="let outputOption of audioOutputOptions" [value]="outputOption.name">
              {{ outputOption.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="volume-container">
      <mat-icon>volume_down</mat-icon>
      <div fxFlex="grow">
        <mat-slider class="full-width" thumbLabel step="1" tickInterval="25" min="0" max="100" [value]="outputVolume"
          displayValue="number" (change)="onChangeOutputVolume($event)"></mat-slider>
      </div>
      <mat-icon>volume_up</mat-icon>
    </div>
  </ng-container>
  <mat-divider></mat-divider>
</div>
<ng-container *ngIf="!isJsSIP">
  <div class="mt-1" fxLayout="row" fxLayoutAlign="start center">
    <span class="title">{{ 'components.settings.input_device' | translate }}</span>
    <mat-icon *ngIf="!audioInputOptions.length" class="error-text">error</mat-icon>
  </div>
  <div class="device-container">
    <ng-container *ngIf="audioInputOptions.length; else noInputDeviceBlock">
      <div class="selector-container">
        <div>
          <mat-form-field class="mat-input-sm mat-input-no-padding" appearance="outline">
            <mat-select [formControl]="audioInputName" (selectionChange)="changeAudioInput($event)">
              <mat-option value="*">Default</mat-option>
              <mat-option *ngFor="let inputOption of audioInputOptions" [value]="inputOption.name">
                {{ inputOption.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="volume-container">
        <mat-icon>mic_none</mat-icon>
        <div fxFlex="grow">
          <mat-slider class="full-width" thumbLabel step="1" tickInterval="25" min="0" max="100" [value]="inputVolume"
            displayValue="number" (change)="onChangeInputVolume($event)"></mat-slider>
        </div>
        <mat-icon>mic</mat-icon>
      </div>
    </ng-container>
  </div>
  <mat-divider></mat-divider>
</ng-container>

<div class="mt-1" fxLayout="row" fxLayoutAlign="start center">
  <span class="title">{{ 'components.settings.choice_ringtone' | translate }}</span>
</div>
<div class="device-container">
  <mat-form-field class="mat-input-sm mat-input-no-padding full-width" appearance="outline">
    <mat-select [formControl]="ringtoneCtrl" (selectionChange)="onChangeRingtone($event)">
      <mat-option [value]="0">Default</mat-option>
      <mat-option *ngFor="let ringtone of ringtones" [value]="ringtone.id">
        {{ ringtone.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="device-container">
  <div class="selector-container">
    <div>
      <a class="flex-link block mt-xs mb-xs" (click)="manageRingtones($event)">
        {{ 'manage_ringtones.content.title'|translate }}
      </a>
    </div>
  </div>
</div>

<mat-divider></mat-divider>

<div class="mt-1" fxLayout="row" fxLayoutAlign="start center">
  <span class="title">{{ 'components.settings.ring_device' | translate }}</span>
  <mat-icon *ngIf="!audioOutputOptions.length" class="error-text">error</mat-icon>
</div>
<div class="device-container">
  <ng-container *ngIf="audioOutputOptions.length; else noRingDeviceOptions">
    <div class="selector-container">
      <mat-form-field class="mat-input-sm mat-input-no-padding" appearance="outline">
        <mat-select [formControl]="ringDeviceName" (selectionChange)="changeRingDevice($event)">
          <mat-option value="*">Default</mat-option>
          <mat-option *ngFor="let ringDeviceOption of ringDeviceOptions" [value]="ringDeviceOption.name">
            {{ ringDeviceOption.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="volume-container">
      <mat-icon>volume_down</mat-icon>
      <div fxFlex="grow">
        <mat-slider class="full-width" thumbLabel step="1" tickInterval="25" min="0" max="100" [value]="ringVolume"
          displayValue="number" (change)="onChangeRingVolume($event)"></mat-slider>
      </div>
      <mat-icon>volume_up</mat-icon>
    </div>
  </ng-container>
</div>
<ng-container *ngIf="!isJsSIP">
  <mat-divider></mat-divider>
  <div class="mt-1">
    <span class="title">{{ 'components.settings.ask_user_on_new_device.title'|translate }}</span>
  </div>
  <div class="mb-1" align="center">
    <mat-slide-toggle [checked]="askUserOnNewDevice === 1" (change)="onChangeAskUserOnnewDevice($event)">
      <span>{{ 'components.settings.ask_user_on_new_device.label'|translate }}</span>
    </mat-slide-toggle>
  </div>
  <mat-divider></mat-divider>
  <div class="mt-1">
    <span class="title">{{ 'user.content.test_headset' | translate }}</span>
  </div>
  <div align="center">
    <a class="flex-link" (click)="checkHeadset()">{{ 'headset_wizard.open_button.label'|translate }}</a>
  </div>
</ng-container>
